import $ from '@modules/jquery-import';
import {$BODY} from '@config/selectors';

class SlideMenu {
    activeMenuId = 'root-slideMenu';
    inactiveMenuStack = [];
    _menuOpen = false;

    constructor ( $container ) {

        this.menuWrap = $container;

        this.initEvents();
    };

    initEvents () {
        $( '[data-action="slide-menu-toggle"]' ).on( 'click', this.handleMenuIconClick );

        $( '#nav-slide--mobile:not(.hidden)' ).on( 'click', e => {
            if ( e.target === e.currentTarget ) {
                this.closeMenu();
            }
        } );

        this.menuWrap
            .on( 'click', 'a[href*="#"]', this.closeMenu );
    }

    handleMenuIconClick = e => {
        !this._menuOpen ? this.openMenu() : this.closeMenu();
    };

    toggleMenuOpen = () => {
        $( '.sideNav' ).toggleClass( 'open' );
    };

    openMenu = () => {
        this._menuOpen = true;
        this.toggleMenuOpen();

        this.menuWrap
            .attr( 'data-overlay', 'active' ) // toggle menu overlay
            .first()
            .scrollTop( 0 )
    };

    closeMenu = () => {
        this._menuOpen = false;
        this.activeMenuId = 'root-slideMenu';
        this.inactiveMenuStack = [];
        this.toggleMenuOpen();
        // reset all menu panes to initial state
        this.menuWrap
            .attr( 'data-overlay', 'inactive' ) // toggle menu overlay
    };

}

export default SlideMenu;
